import React from "react";

function ExpertHumanIcon() {
  return (
    <svg
      id="Group_3644"
      data-name="Group 3644"
      xmlns="http://www.w3.org/2000/svg"
      width="21.305"
      height="27.649"
      viewBox="0 0 21.305 27.649"
    >
      <path
        id="Path_3599"
        data-name="Path 3599"
        d="M846.414,190.868h1.62a.057.057,0,0,1,.015.047c0,.017-.006.025-.009.025-.117.086-.155.25-.3.307a.475.475,0,0,1-.128.018,6.563,6.563,0,0,1-.859-.014c-.157-.053-.223-.207-.34-.306A.06.06,0,0,1,846.414,190.868Z"
        transform="translate(-836.625 -190.868)"
        fill="#00173a"
      />
      <path
        id="Path_3600"
        data-name="Path 3600"
        d="M870.465,190.917a.076.076,0,0,0,.007-.049h.324a.125.125,0,0,1,.012.045A.234.234,0,0,1,870.465,190.917Z"
        transform="translate(-859.063 -190.868)"
        fill="#404040"
      />
      <path
        id="Path_3601"
        data-name="Path 3601"
        d="M842.047,190.868a.092.092,0,0,1,.012.046.235.235,0,0,1-.344,0,.066.066,0,0,0,.008-.048Z"
        transform="translate(-832.259 -190.868)"
        fill="#404040"
      />
      <path
        id="Path_3602"
        data-name="Path 3602"
        d="M711.425,191.54l.344,0c.154.029.2.16.26.277.107.156.022.278-.069.4a.905.905,0,0,1-.42.2,4.422,4.422,0,0,0-2.917,2.209,5.365,5.365,0,0,0-.574,3c0,.07-.008.16.085.175a.285.285,0,0,0,.3-.135.884.884,0,0,1,.521-.441c.5-.061,1-.017,1.506-.069a8.823,8.823,0,0,0,3.328-1.021c.182-.1.352-.217.538-.309a.863.863,0,0,1,1.144.2c.345.378.711.738,1.041,1.13a.977.977,0,0,1,.222.366.352.352,0,0,0,.349.294,7.109,7.109,0,0,0-.231-2.443,4.519,4.519,0,0,0-3.168-2.939,1.753,1.753,0,0,1-.384-.122.363.363,0,0,1-.191-.485c.072-.107.1-.25.26-.279l.343,0a5.257,5.257,0,0,1,3.6,2.678,5.2,5.2,0,0,1,.667,2.659c0,.459,0,.918,0,1.376a.555.555,0,0,0,.112.347,1.811,1.811,0,0,1-1.145,2.845c-.189.037-.285.094-.32.3a3.863,3.863,0,0,1-1.346,2.328.4.4,0,0,0-.167.364c.025.347-.132.774.059,1.02s.6.28.918.4c1.37.532,2.742,1.059,4.112,1.592a3.846,3.846,0,0,1,2.49,3.712.513.513,0,0,1-.237.479c-.484.074-.662-.074-.663-.593a2.827,2.827,0,0,0-.71-1.929,3.087,3.087,0,0,0-1.206-.841c-.9-.353-1.794-.7-2.69-1.049-.191-.075-.276-.007-.356.156-.4.8-.787,1.6-1.2,2.389a.817.817,0,0,1-.934.519.7.7,0,0,1-.278-.1c-.145-.1-.241-.06-.333.081a.718.718,0,0,0-.129.535c.193,1.144.38,2.289.579,3.432a.27.27,0,0,0,.265.25c.2.027.393.047.587.09a.746.746,0,0,1,.429,1.279c-.1.121-.228.225-.378.4.578,0,1.1,0,1.666,0-.142-.166-.274-.275-.378-.406a.748.748,0,0,1,.47-1.28c.282-.056.568-.09.854-.125.214-.026.286-.131.283-.339-.007-.674,0-1.349,0-2.024,0-.436.182-.678.491-.669s.463.242.465.667c0,.288.005.576,0,.863a.43.43,0,0,1-.019.107.607.607,0,0,1,.24-.286.735.735,0,0,1,.381-.122.794.794,0,0,1,.416.094.714.714,0,0,1,.278.288c.176.324.333.658.5.987a1.244,1.244,0,0,0,.131.235.484.484,0,0,0,.49.156c.159-.034.077-.214.085-.33a5.35,5.35,0,0,1,.047-.994c.073-.288.212-.371.514-.325a.428.428,0,0,1,.344.477c0,.414,0,.828,0,1.242a.2.2,0,0,0,.138.219.658.658,0,0,1,.213,1.135c-.295.3-.6.6-.908.886a.314.314,0,0,0-.114.327c.077.388.135.779.205,1.168a.73.73,0,0,1-.25.8.7.7,0,0,1-.81,0c-.331-.181-.673-.341-1-.53a.409.409,0,0,0-.467-.007c-.341.2-.7.369-1.046.555a.678.678,0,0,1-.784-.027.7.7,0,0,1-.247-.748c.061-.317.1-.639.171-.955.029-.139-.007-.169-.14-.169q-1.377.006-2.754,0c-.143,0-.157.045-.129.174.065.307.106.62.164.929a.717.717,0,0,1-.252.773.683.683,0,0,1-.786.018c-.364-.2-.732-.381-1.093-.581a.321.321,0,0,0-.349,0c-.353.2-.714.377-1.069.569a.7.7,0,0,1-.809-.01.716.716,0,0,1-.248-.774c.06-.318.106-.638.17-.955.022-.11,0-.144-.112-.144q-1.4,0-2.808,0c-.149,0-.126.073-.108.171.057.309.1.622.163.929a.707.707,0,0,1-.245.773.693.693,0,0,1-.809.011c-.347-.188-.7-.362-1.046-.556a.359.359,0,0,0-.4,0c-.351.2-.713.378-1.069.569a.686.686,0,0,1-.786-.017.7.7,0,0,1-.255-.748c.067-.39.13-.78.208-1.167a.376.376,0,0,0-.13-.4c-.307-.277-.6-.569-.89-.866a.656.656,0,0,1,.221-1.132c.159-.068.129-.168.13-.277.005-1.188-.027-2.377.021-3.563a3.63,3.63,0,0,1,2.409-3.37c1.6-.674,3.238-1.273,4.863-1.893a.383.383,0,0,0,.288-.4,1.531,1.531,0,0,0-.573-1.44,3.321,3.321,0,0,1-1.049-2.047c-.025-.151-.069-.224-.24-.252a1.794,1.794,0,0,1-1.185-2.862.442.442,0,0,0,.077-.3c.016-.746-.03-1.492.052-2.238A5.422,5.422,0,0,1,711.425,191.54Z"
        transform="translate(-701.969 -191.492)"
        fill="#00173a"
      />
      <path
        id="Path_3603"
        data-name="Path 3603"
        d="M886.069,427c-.344.035-.46.151-.468.495-.008.369-.007.738,0,1.106,0,.133-.034.158-.169.15-.333-.018-.6-.09-.715-.463a6.727,6.727,0,0,0-.372-.775c-.134-.287-.289-.541-.652-.563a.793.793,0,0,0-.758.484c0-.407,0-.815,0-1.222a.462.462,0,0,0-.183-.426.374.374,0,0,0-.408-.024.415.415,0,0,0-.222.4c0,.747-.012,1.493.007,2.24.006.252-.057.343-.315.357a7.075,7.075,0,0,0-.932.138.664.664,0,0,0-.383,1.145c.148.166.312.318.493.5h-2c.159-.158.292-.3.431-.428a.7.7,0,0,0,.246-.748.667.667,0,0,0-.617-.483.439.439,0,0,1-.053-.011c-.25-.058-.584.025-.738-.159-.141-.169-.119-.476-.161-.723-.17-.991-.327-1.985-.512-2.974-.064-.344.182-.522.324-.758.051-.085.106.014.15.041a.767.767,0,0,0,1.247-.365c.4-.81.81-1.62,1.207-2.434.077-.158.134-.221.333-.141.938.382,1.9.716,2.827,1.114a2.934,2.934,0,0,1,1.914,2.665c.005.081.006.162.01.243.017.413.161.537.578.5a.286.286,0,0,0-.219.354,3.485,3.485,0,0,1,0,.511A.256.256,0,0,0,886.069,427Z"
        transform="translate(-865.696 -405.73)"
        fill="#c8e2ff"
      />
      <path
        id="Path_3604"
        data-name="Path 3604"
        d="M805.963,196.26l.375-.164a1.66,1.66,0,0,1,.846-.318.6.6,0,0,0,.235-.049l.114,0c.037.349.1.415.505.519a4.548,4.548,0,0,1,3.374,3.2,7.289,7.289,0,0,1,.173,2.221c0,.048.013.13-.066.115-.127-.023-.329.015-.362-.12-.16-.664-.741-.995-1.125-1.48-.05-.063-.106-.123-.16-.183a.794.794,0,0,0-1.126-.192,11.638,11.638,0,0,1-1.363.706,8.679,8.679,0,0,1-3.5.654c-.171,0-.342.007-.512.011-.177-.028-.121-.173-.126-.274a4.911,4.911,0,0,1,1.143-3.418A3.973,3.973,0,0,1,805.963,196.26Z"
        transform="translate(-796.39 -195.395)"
        fill="#00173a"
      />
      <path
        id="Path_3605"
        data-name="Path 3605"
        d="M850.059,195.648c-.053.11-.162.081-.252.107-.278.08-.552.172-.828.26a.58.58,0,0,0,.112-.378Z"
        transform="translate(-839.031 -195.314)"
        fill="#00173a"
      />
      <path
        id="Path_3606"
        data-name="Path 3606"
        d="M735.06,422.666a1.415,1.415,0,0,1,.4-.211c.944-.366,1.89-.73,2.831-1.107.171-.068.238-.04.317.124.375.775.765,1.542,1.149,2.313s.7.87,1.422.437a1.082,1.082,0,0,1,.31,1.139c-.206,1.048-.369,2.105-.541,3.16-.029.18-.094.261-.288.269a4.087,4.087,0,0,0-.666.1.659.659,0,0,0-.381,1.1c.154.182.342.334.559.543h-2.029l.444-.453a.681.681,0,0,0,.22-.73.669.669,0,0,0-.595-.475c-.329-.046-.656-.111-.987-.143-.173-.017-.222-.075-.22-.248.01-.765,0-1.529.005-2.294a.438.438,0,0,0-.258-.461c-.274-.117-.547.088-.553.425-.009.42,0,.841-.021,1.272a.9.9,0,0,0-.485-.47.662.662,0,0,0-.8.337c-.153.273-.289.556-.433.835-.146-.037-.126-.163-.124-.261.018-1.228-.077-2.459.059-3.683A2.3,2.3,0,0,1,735.06,422.666Z"
        transform="translate(-732.135 -405.72)"
        fill="#c8e2ff"
      />
      <path
        id="Path_3607"
        data-name="Path 3607"
        d="M821.522,268.209a11.034,11.034,0,0,0,2.4-.455,9.037,9.037,0,0,0,2.022-.931.249.249,0,0,1,.394.062,4.455,4.455,0,0,0,.549.592,1.166,1.166,0,0,1,.406,1.04c-.045.978.04,1.96-.042,2.938a3.254,3.254,0,0,1-3.894,2.847,3.448,3.448,0,0,1-1.853-2.617,8.681,8.681,0,0,1-.059-1.637c-.007-.493,0-.987,0-1.48A.49.49,0,0,1,821.522,268.209Z"
        transform="translate(-813.354 -261.618)"
        fill="#f1d0a4"
      />
      <path
        id="Path_3608"
        data-name="Path 3608"
        d="M939.124,529.467c.212-.036.422-.084.635-.107a.86.86,0,0,0,.68-.378.288.288,0,0,1,.168-.078.621.621,0,0,0,.571-.378.128.128,0,0,1,.151-.085,1.35,1.35,0,0,0,1.446.992,1.391,1.391,0,0,1,.537.084c-.248.27-.493.555-.759.821a.826.826,0,0,0-.262.826c.08.358.124.723.189,1.114a2.042,2.042,0,0,1-.631-.3,1.232,1.232,0,0,0-1.538-.074c-.15-.013-.1-.123-.087-.2.021-.2.057-.407.1-.609a.427.427,0,0,0-.121-.417c-.286-.283-.554-.583-.864-.841C939.224,529.739,939.084,529.654,939.124,529.467Z"
        transform="translate(-923.07 -505.595)"
        fill="#fac756"
      />
      <path
        id="Path_3609"
        data-name="Path 3609"
        d="M725.77,528.475a1.328,1.328,0,0,0,1.441.987,3.48,3.48,0,0,1,.566.086c-.245.259-.466.524-.719.753a.914.914,0,0,0-.317.984c.082.328.116.669.176,1.03a2.464,2.464,0,0,1-.7-.345,1.173,1.173,0,0,0-1.464-.041c-.144-.031-.1-.142-.088-.229a3.692,3.692,0,0,1,.088-.528.513.513,0,0,0-.181-.548c-.28-.262-.586-.5-.84-.786-.085-.1-.21-.178-.164-.34.2-.035.4-.083.6-.1a.879.879,0,0,0,.7-.381.326.326,0,0,1,.17-.076.633.633,0,0,0,.59-.394A.117.117,0,0,1,725.77,528.475Z"
        transform="translate(-722.098 -505.628)"
        fill="#fac756"
      />
      <path
        id="Path_3610"
        data-name="Path 3610"
        d="M831.324,529.486c.2-.036.4-.085.606-.1a.879.879,0,0,0,.7-.381.268.268,0,0,1,.143-.07.66.66,0,0,0,.614-.4.115.115,0,0,1,.134-.067,1.338,1.338,0,0,0,1.446.988,3.184,3.184,0,0,1,.545.085c-.264.283-.519.572-.791.845a.8.8,0,0,0-.244.781c.076.368.129.741.2,1.14a2.34,2.34,0,0,1-.679-.333,1.2,1.2,0,0,0-1.49-.051c-.146-.029-.1-.14-.091-.227a4.57,4.57,0,0,1,.092-.555.509.509,0,0,0-.163-.5c-.269-.288-.588-.521-.86-.806C831.4,529.732,831.277,529.648,831.324,529.486Z"
        transform="translate(-822.561 -505.614)"
        fill="#fac756"
      />
      <path
        id="Path_3611"
        data-name="Path 3611"
        d="M810.526,288.05c0,.906,0,1.813,0,2.719a3.7,3.7,0,0,0,1.741,3.282.67.67,0,0,1,.095.092,3.209,3.209,0,0,1-2.7-2.935c-.035-1-.012-1.995-.021-2.992,0-.141.04-.19.183-.181C810.059,288.05,810.293,288.046,810.526,288.05Z"
        transform="translate(-802.357 -281.459)"
        fill="#f1ba87"
      />
      <path
        id="Path_3612"
        data-name="Path 3612"
        d="M846.108,387.51a4.627,4.627,0,0,0,1.971-.112c.034-.011.07-.017.1-.028.412-.133.395-.132.418.316a1.047,1.047,0,0,1-.285.8c-.431.493-.837,1.009-1.238,1.527-.135.174-.207.163-.329-.005-.2-.283-.428-.552-.644-.827a2.839,2.839,0,0,1-.082-1.1A.773.773,0,0,1,846.108,387.51Z"
        transform="translate(-836.264 -374.002)"
        fill="#f1ba87"
      />
      <path
        id="Path_3613"
        data-name="Path 3613"
        d="M869.675,412.411l-1.611-1.145c.525-.648,1.044-1.287,1.561-1.929a.138.138,0,0,1,.186-.039c.358.141.716.284,1.076.417.1.036.095.076.055.156C870.521,410.711,870.1,411.553,869.675,412.411Z"
        transform="translate(-856.825 -394.5)"
        fill="#c8e2ff"
      />
      <path
        id="Path_3614"
        data-name="Path 3614"
        d="M811.252,411.493l-1.6,1.133-1.109-2.226c-.213-.428-.216-.435.222-.594.291-.105.6-.37.866-.276.247.088.4.435.6.672q.493.605.981,1.215A.519.519,0,0,1,811.252,411.493Z"
        transform="translate(-801.204 -394.715)"
        fill="#c8e2ff"
      />
      <path
        id="Path_3615"
        data-name="Path 3615"
        d="M723.92,441.3a4.036,4.036,0,0,0-.644,2.387c0,.932,0,1.864,0,2.8,0,.095-.034.2.046.282-.028.065-.053.132-.084.2a.687.687,0,0,1-.739.417c-.089-.007-.105-.044-.1-.115a34.957,34.957,0,0,1,.075-3.962A2.711,2.711,0,0,1,723.92,441.3Z"
        transform="translate(-720.996 -424.354)"
        fill="#dbecff"
      />
      <path
        id="Path_3616"
        data-name="Path 3616"
        d="M794.206,203.641c-.278.223-.6.39-.871.62a4.9,4.9,0,0,0-1.7,2.874,2.947,2.947,0,0,0-.019,1.425.9.9,0,0,0-.463.46c-.081.193-.3.13-.452.168-.062.015-.058-.075-.06-.126a5.751,5.751,0,0,1,.59-3.211,4.628,4.628,0,0,1,2.813-2.2A.785.785,0,0,1,794.206,203.641Z"
        transform="translate(-784.633 -202.777)"
        fill="#00173a"
      />
      <path
        id="Path_3617"
        data-name="Path 3617"
        d="M847.418,478.927a.685.685,0,0,0-.917.406c-.061.118-.115.239-.172.359-.1.006-.075-.047-.052-.1.131-.785.264-1.57.389-2.356.025-.155.093-.222.248-.2a.984.984,0,0,0,.134,0c.554,0,.554,0,.627.563-.033.338-.083.673-.145,1.007A.544.544,0,0,1,847.418,478.927Z"
        transform="translate(-836.494 -457.665)"
        fill="#ff7b16"
      />
      <path
        id="Path_3618"
        data-name="Path 3618"
        d="M718.028,543.608a3.5,3.5,0,0,0,.744.8.709.709,0,0,0,.128.1c.54.325.38.814.3,1.282-.015.087-.071.17.014.249l-.767.423c.072-.433.124-.814.2-1.189a.785.785,0,0,0-.234-.758c-.274-.282-.537-.574-.8-.854A1.044,1.044,0,0,1,718.028,543.608Z"
        transform="translate(-716.557 -519.738)"
        fill="#f3b437"
      />
      <path
        id="Path_3619"
        data-name="Path 3619"
        d="M933.553,543.632a.931.931,0,0,0,.291.342c.226.19.41.432.644.611a.826.826,0,0,1,.286,1c-.042.149-.13.316-.032.483l-.764.422c.073-.423.13-.795.2-1.163a.817.817,0,0,0-.251-.806c-.27-.262-.519-.545-.788-.829A1.008,1.008,0,0,1,933.553,543.632Z"
        transform="translate(-917.499 -519.759)"
        fill="#f3b437"
      />
      <path
        id="Path_3620"
        data-name="Path 3620"
        d="M825.839,543.625a2.009,2.009,0,0,0,.536.594c.224.207.445.417.658.635a.4.4,0,0,1,.081.348c-.032.284-.18.559-.088.855l-.765.422c.07-.422.118-.793.2-1.158a.824.824,0,0,0-.261-.824c-.267-.262-.514-.546-.766-.817A.947.947,0,0,1,825.839,543.625Z"
        transform="translate(-817.077 -519.753)"
        fill="#f3b437"
      />
      <path
        id="Path_3621"
        data-name="Path 3621"
        d="M785.131,298.154c0,.269-.005.539,0,.808,0,.146-.048.16-.177.125a1.012,1.012,0,0,1-.734-1.008,1.068,1.068,0,0,1,.771-.936c.119-.026.139.022.138.122C785.129,297.561,785.131,297.857,785.131,298.154Z"
        transform="translate(-778.656 -289.945)"
        fill="#e1a66e"
      />
      <path
        id="Path_3622"
        data-name="Path 3622"
        d="M920.588,298.324a.942.942,0,0,1-.719.451c0-.644,0-1.271,0-1.9,0-.138.081-.117.159-.092a.917.917,0,0,1,.607.486A2.538,2.538,0,0,1,920.588,298.324Z"
        transform="translate(-905.123 -289.601)"
        fill="#e2a66e"
      />
      <path
        id="Path_3623"
        data-name="Path 3623"
        d="M835.359,387.052q0,.835,0,1.669c-.267-.322-.533-.646-.8-.966-.113-.134-.059-.29-.066-.437-.009-.167,0-.334,0-.516Z"
        transform="translate(-825.515 -373.544)"
        fill="#e2a66e"
      />
      <path
        id="Path_3624"
        data-name="Path 3624"
        d="M847.386,449.05c-.268,0-.536.011-.8.01-.121,0-.494-.407-.473-.519.008-.043.062-.081.1-.111.165-.122.334-.239.5-.358.311-.22.311-.22.62.048.009.017.018.041.008.05-.292.241-.182.473.008.709C847.387,448.925,847.427,448.983,847.386,449.05Z"
        transform="translate(-836.355 -430.519)"
        fill="#ff7b16"
      />
      <path
        id="Path_3625"
        data-name="Path 3625"
        d="M863.408,486.753a5.562,5.562,0,0,1,.258-1.33l.341,1.993c.024.055.043.108-.052.1C863.809,487.237,863.728,486.91,863.408,486.753Z"
        transform="translate(-852.484 -465.492)"
        fill="#ffa45e"
      />
      <path
        id="Path_3626"
        data-name="Path 3626"
        d="M743.908,519.932c-.025.024-.066.044-.074.073-.123.422-.464.457-.82.466l.558-1.162A2.9,2.9,0,0,1,743.908,519.932Z"
        transform="translate(-740.236 -497.085)"
        fill="#f2b337"
      />
      <path
        id="Path_3627"
        data-name="Path 3627"
        d="M851.722,519.98c-.026.024-.066.043-.075.072-.122.42-.461.459-.817.468l.56-1.159A2.732,2.732,0,0,1,851.722,519.98Z"
        transform="translate(-840.757 -497.134)"
        fill="#f1b337"
      />
      <path
        id="Path_3628"
        data-name="Path 3628"
        d="M959.545,519.462c-.026.023-.068.042-.076.07-.122.417-.459.459-.814.471l.584-1.2Z"
        transform="translate(-941.285 -496.616)"
        fill="#f1b336"
      />
      <path
        id="Path_3629"
        data-name="Path 3629"
        d="M860.414,451.909l-.2-.309c-.187-.284-.178-.329.089-.538a.41.41,0,0,0,.064-.083c.082.052.169.1.246.157.112.084.331.156.311.258a1.447,1.447,0,0,1-.286.474C860.579,451.947,860.493,451.924,860.414,451.909Z"
        transform="translate(-849.383 -433.378)"
        fill="#ffa45e"
      />
      <path
        id="Path_3630"
        data-name="Path 3630"
        d="M930.317,305.263a3.907,3.907,0,0,1,.046-1.053A.919.919,0,0,1,930.317,305.263Z"
        transform="translate(-914.852 -296.54)"
        fill="#eeb886"
      />
      <path
        id="Path_3631"
        data-name="Path 3631"
        d="M845.816,514.865l.052.1a.175.175,0,0,1-.085.135A.221.221,0,0,1,845.816,514.865Z"
        transform="translate(-836.033 -492.941)"
        fill="#712727"
      />
      <path
        id="Path_3632"
        data-name="Path 3632"
        d="M871.481,514.973l.052-.1c.061.064.052.141.049.231C871.5,515.081,871.492,515.027,871.481,514.973Z"
        transform="translate(-860.011 -492.947)"
        fill="#712f2f"
      />
      <path
        id="Path_3633"
        data-name="Path 3633"
        d="M796.484,307.941v-.4A.532.532,0,0,1,796.484,307.941Z"
        transform="translate(-790.088 -299.649)"
        fill="#eab17c"
      />
    </svg>
  );
}
export default ExpertHumanIcon;
